import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  linkBox: {
    display: 'inline-block',

    '&:hover > a': {
      color: theme.primary.p3,
      cursor: 'pointer',
    },
  },
  box: {
    ...dFlex('initial', 'initial'),
    flexDirection: 'column',
  },
  tooltip: {
    ...dFlex('initial', 'initial'),
    flexDirection: 'column',
    gap: '5px',

    '& a': {
      color: theme.primary.p3,

      '&:hover': {
        opacity: '0.8',
      },
    },
  },
  isOutOfRange: {
    fontSize: 16,
    color: theme.accent.a4,
  },
}));

export default useStyles;
